// src/components/pages/Pessoa/tabs/PessoaTabFinanceiro.jsx

import { Box, Typography } from '@mui/material';

import Select from '../../../form/Select';
import DataList from '../../../form/DataList';
import Checkbox from '../../../form/Checkbox';

export default function PessoaTabFinanceiro({ module }) {
    const {
        dados,
        optionsFormaCliente,
        optionsFormaFornecedor,
        optionsConta,
        optionsPCliente,
        optionsPFornecedor,
        centroCustoCliente,
        centroCustoFornecedor,
        optionsCCC,
        optionsCCF,
        handleFinanceiroChange,
        handleCentroCustoClienteChange,
        handleCentroCustoFornecedorChange,
    } = module;

    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">Modulo de Cliente</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Select
                    name="contaClienteId"
                    text="Conta Cliente"
                    options={optionsConta}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.contaClienteId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Select
                    name="formaClienteId"
                    text="Forma Cliente"
                    options={optionsFormaCliente}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.formaClienteId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Select
                    name="prazoClienteId"
                    text="Prazo Cliente"
                    options={optionsPCliente}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.prazoClienteId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <DataList
                    text="Centro Custo Cliente"
                    name="centroCustoCliente.descricao"
                    filteredOptions={optionsCCC}
                    handleOnChange={handleCentroCustoClienteChange}
                    value={centroCustoCliente?.descricao || ''}
                    inputWidth="250px"
                />
            </Box>

            <Typography variant="h6">Modulo de Fornecedor</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Select
                    name="contaFornecedorId"
                    text="Conta Fornecedor"
                    options={optionsConta}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.contaFornecedorId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Select
                    name="formaFornecedorId"
                    text="Forma Fornecedor"
                    options={optionsFormaFornecedor}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.formaFornecedorId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Select
                    name="prazoFornecedorId"
                    text="Prazo Fornecedor"
                    options={optionsPFornecedor}
                    handleOnChange={handleFinanceiroChange}
                    value={dados.prazoFornecedorId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <DataList
                    text="Centro Custo Fornecedor"
                    name="centroCustoFornecedor.descricao"
                    filteredOptions={optionsCCF}
                    handleOnChange={handleCentroCustoFornecedorChange}
                    value={centroCustoFornecedor?.descricao || ''}
                    inputWidth="250px"
                />
            </Box>

            <Typography variant="h6">Modulo Locação de Imóveis</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Checkbox
                    title="Quando marcado torna a pessoa administrador de imóveis"
                    text="Administrador"
                    name="administrador"
                    handleOnChange={handleFinanceiroChange}
                    value={dados.administrador}
                    checked={!!dados.administrador}
                />

                <Checkbox
                    title="Quando marcado torna a pessoa locador de imóveis"
                    text="Locador"
                    name="locador"
                    handleOnChange={handleFinanceiroChange}
                    value={dados.locador}
                    checked={!!dados.locador}
                />

                <Checkbox
                    title="Quando marcado torna a pessoa locatário de imóveis"
                    text="Locatário"
                    name="locatario"
                    handleOnChange={handleFinanceiroChange}
                    value={dados.locatario}
                    checked={!!dados.locatario}
                />

                <Checkbox
                    title="Quando marcado torna a pessoa fiador de imóveis"
                    text="Fiador"
                    name="fiador"
                    handleOnChange={handleFinanceiroChange}
                    value={dados.fiador}
                    checked={!!dados.fiador}
                />
            </Box>
        </Box>
    );
}
